import React, { useState, useEffect } from "react";
import { showData } from "../../Utils/APIs/commonShowAPI";
import axios from "axios";
import CommonDropdownWithId from "../../Components/common/commonDropdownWithId";
import { updateData } from "../../Utils/APIs/commonUpdateAPI";
import { haversineDistance } from "../../Utils/distanceCalculate";
import { useNavigate } from "react-router-dom";
import { getCookie } from "../../Utils/cookies";

const Index = ({ _id, setComplaintId }) => {
  const Navigate = useNavigate();
  useEffect(() => {
    const token = getCookie("token");
    if (!token) {
      Navigate("/");
    }
  }, []);
  const empData = JSON.parse(getCookie("empData"));
  const [complaintData, setComplaintData] = useState({});
  const [stage, setStage] = useState(null);
  const [priority, setPriority] = useState(null);
  const [remark, setRemark] = useState(null);
  const [fieldSalesList, setFieldSalesList] = useState([]);
  const [selectedEmployee, setSelectedEmployee] = useState(null);
  const [updateResponse, setUpdateResponse] = useState("");
  const [externalServicePerson, setExternalServicePerson] = useState([]);
  const [updateBtnClicked, setUpdateBtnClicked] = useState(false);
  const [complaintDetails, setComplaintDetails] = useState(null); // complaint details
  const [complaintOtherDetails, setComplaintOtherDetails] = useState(null); // complaint details
  const [errorList, setErrorList] = useState([]); // complaint details
  const [authority, setAuthority] = useState([]);
  const [selectedAuthority, setSelectedAuthority] = useState(null);

  useEffect(() => {
    showData(`farmer/showComplaint?complaintId=${_id}`, setComplaintData).then(
      (status) => {
        if (status) {
          showData(
            `/external/findServicePersonById?id=${status[0].assignEmployee}`,
            setExternalServicePerson,
          );
          setUpdateBtnClicked(false);
        }
      },
    );
  }, [_id, updateBtnClicked]);
  let imageArray = [];
  complaintData?.[0]?.RMUData?.forEach((rmu) => {
    [
      rmu?.simPhoto?.[0],
      rmu?.finalFoundation?.[0],
      rmu?.panelPhoto?.[0],
      rmu?.photoWithWater?.[0],
      rmu?.photoWithController?.[0],
    ]
      .filter(Boolean)
      .forEach((photo) => imageArray.push(photo));
  });
  const updated_data = imageArray.map((photo) => {
    if (photo.includes("http://88.222.214.93:8001")) {
      return photo.replace(
        "http://88.222.214.93:8001",
        "https://service.galosolar.com/api",
      );
    } else {
      return `https://service.galosolar.com/api${photo}`;
    }
  });
  //------- complaint details (start) ----------
  useEffect(() => {
    const fetchData = async () => {
      try {
        const sendRequest2 = await axios.get(
          `${process.env.REACT_APP_API_URL}/common/showErrorList`,
        );
        setErrorList(sendRequest2.data.data);
      } catch (error) {
        console.log("Something went wrong");
      }
    };
    fetchData();
  }, []);
  //------- complaint details (end) ----------
  const handleStageChange = (stage) => {
    setStage(stage);
  };
  const updateValue = {
    priority: priority,
    stageId: stage,
    complaintId: _id,
    assignEmployee: selectedEmployee,
    remark: remark,
    complaintDetails,
    authority: selectedAuthority,
  };
  useEffect(() => {
    (async function fetchFieldSalesData() {
      try {
        await showData("external/fieldEmployeeList", setFieldSalesList);
      } catch (error) {
        console.error(error);
      }
    })();
  }, []);
  const updateComplaint = (e) => {
    e.preventDefault();
    updateData("service/updateComplaint", setUpdateResponse, updateValue).then(
      (status) => {
        if (!status) {
          alert("please fill updated value");
        }
        if (status) {
          alert("Stage Updated Successfully.");
          // setUpdateBtnClicked(true);
          setComplaintId(null);
        }
      },
    );
  };
  // for image show in full screen
  const [isOpen, setIsOpen] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);

  const handleImageClick = (imageSrc) => {
    setSelectedImage(imageSrc);
    setIsOpen(true);
  };

  const handleCloseModal = () => {
    setIsOpen(false);
  };

  //return Quantity
  const [showReturnQuantity, setShowReturnQuantity] = useState([]);
  const fetchReturnQuantity = async (contact, contact2) => {
    try {
      await showData(
        `external/incomingItemsData?contact=${contact}&contact2=${contact2}`,
        setShowReturnQuantity,
      );
    } catch (error) {
      console.error("Error fetching return quantity:", error);
    }
  };

  useEffect(() => {
    if (empData.role !== "Tollfree") {
      fetchReturnQuantity(
        complaintData?.[0]?.Farmer[0]?.contact,
        complaintData?.[0]?.contact,
      );
    }
  }, [complaintData, empData.role]); // Added empData.role to dependency array

  // for show Authority
  useEffect(() => {
    showData("common/showAuthority", setAuthority);
  }, []);
  const complaintReject = () => {
    if (window.confirm("Are you sure to reject this complaint?")) {
      if (remark === null || remark === "") {
        alert("Please add remark for reject complaint.");
        return;
      }
      updateData("admin/rejectComplaint", setUpdateResponse, {
        complaintId: _id,
        remark: remark,
      }).then((status) => {
        if (status) {
          alert("Complaint Rejected Successfully.");
          Navigate(
            `/complaintList/${complaintData?.[0]?.Stage[0]?._id.toString()}`,
          );
          setUpdateBtnClicked(true);
        }
      });
    }
  };
  return complaintData !== undefined ? (
    <div className="h-full overflow-y-auto">
      <div className=" flex flex-col">
        <div>
          <h1 className=" text-2xl font-semibold tracking-widest text-center p-2 bg-gray-900 text-gray-100">
            C<span className="text-lg">OMPLAINT</span> D
            <span className="text-lg">ETAILS</span>
          </h1>
        </div>
        <div className="flex flex-row justify-around bg-gray-200 ">
          <h1 className=" text-xl font-semibold  tracking-widest p-2">
            F<span className="text-md">armer</span> N
            <span className="text-md">
              ame - {complaintData?.[0]?.Farmer[0]?.farmerName}
            </span>
          </h1>
          <h1 className=" text-xl font-semibold  tracking-widest p-1">
            S<span className="text-md">aral</span> I
            <span className="text-md">
              d - {complaintData?.[0]?.Farmer[0]?.saralId}
            </span>
          </h1>
        </div>
        <div className=" flex flex-row justify-around p-1">
          <div className="mt-3">
            <table className="text-left">
              <tr>
                <th className="text-sm">Father Or Husband </th>
                <td className="text-sm">
                  : {complaintData?.[0]?.Farmer[0]?.fatherOrHusbandName}
                </td>
              </tr>
              <tr>
                <th className="text-sm">Installation Date </th>
                <td className="text-sm">
                  : {complaintData?.[0]?.Farmer[0]?.installationDate}
                </td>
              </tr>
              <tr>
                <th className="text-sm"> HP </th>
                <td className="text-sm">
                  : {complaintData?.[0]?.Farmer[0]?.HP}
                </td>
              </tr>
              <tr>
                <th className="text-sm">State</th>
                <td className="text-sm">
                  : {complaintData?.[0]?.Farmer[0]?.state}
                </td>
              </tr>
              <tr>
                <th className="text-sm">District</th>
                <td className="text-sm">
                  : {complaintData?.[0]?.Farmer[0]?.district}
                </td>
              </tr>
              <tr>
                <th className="text-sm"> Block </th>
                <td className="text-sm">
                  : {complaintData?.[0]?.Farmer[0]?.block}
                </td>
              </tr>
              <tr>
                <th className="text-sm"> Address</th>
                <td className="text-sm">
                  : {complaintData?.[0]?.Farmer[0]?.address}
                </td>
              </tr>
              <tr>
                <th className="text-sm">Village</th>
                <td className="text-sm">
                  : {complaintData?.[0]?.Farmer[0]?.village}
                </td>
              </tr>
              <tr>
                <th className="text-sm">Initial Longitude </th>
                <td className="text-sm">
                  : {complaintData?.[0]?.Farmer[0]?.longitude}
                </td>
              </tr>
              <tr>
                <th className="text-sm">Initial Latitude </th>
                <td className="text-sm">
                  : {complaintData?.[0]?.Farmer[0]?.latitude}
                </td>
              </tr>
              <tr>
                <th className="text-sm">Pump Type </th>
                <td className="text-sm">
                  : {complaintData?.[0]?.Farmer[0]?.pump_type}
                </td>
              </tr>
              <tr>
                <th className="text-sm">AC/DC </th>
                <td className="text-sm">
                  : {complaintData?.[0]?.Farmer[0]?.AC_DC}
                </td>
              </tr>
              <tr>
                <th className="text-sm">Department </th>
                <td className="text-sm">
                  : {complaintData?.[0]?.Farmer[0]?.department}
                </td>
              </tr>
              <tr>
                <th className="text-sm">Visited Longitude </th>
                <td className="text-sm">
                  : {complaintData?.[0]?.RMUData[0]?.longitude}
                </td>
              </tr>
              <tr>
                <th className="text-sm">Visited Latitude </th>
                <td className="text-sm">
                  : {complaintData?.[0]?.RMUData[0]?.latitude}
                </td>
              </tr>
              <hr />
              <tr>
                <th className="text-sm">Service Person Name </th>
                <td className="text-sm">
                  : {showReturnQuantity[0]?.servicePerson?.name}
                </td>
              </tr>
              <tr>
                <th className="text-sm">Serial Number </th>
                <td className="text-sm">
                  : {showReturnQuantity[0]?.serialNumber}
                </td>
              </tr>
              <tr>
                <th className="text-sm">Warehouse</th>
                <td className="text-sm">
                  : {showReturnQuantity[0]?.warehouse}
                </td>
              </tr>
              <tr>
                <th className="text-sm">Tracking Id</th>
                <td className="text-sm">: {complaintData?.[0]?.trackingId}</td>
              </tr>
            </table>
            <div className="overflow-x-auto">
              <table className=" table-auto border-collapse border border-gray-300">
                <thead>
                  <tr className="bg-gray-100">
                    <th className="px-3 py-1 border border-gray-300">
                      Item Name
                    </th>
                    <th className="px-3 py-1 border border-gray-300">
                      Item Quantity
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {showReturnQuantity.length > 0 ? (
                    showReturnQuantity.map((item, index) =>
                      // Iterate through each 'items' array in the current object
                      item.items.map((subItem, subIndex) => (
                        <tr
                          key={`${index}-${subIndex}`}
                          className="odd:bg-gray-50 even:bg-white"
                        >
                          <td className="px-3 py-1 border border-gray-300">
                            {subItem.itemName}
                          </td>
                          <td className="px-3 py-1 border border-gray-300">
                            {subItem.quantity}
                          </td>
                        </tr>
                      )),
                    )
                  ) : (
                    <tr>
                      <td
                        colSpan="9"
                        className="text-center px-4 py-2 border border-gray-300"
                      >
                        No return items found.
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
          <div className="mt-3">
            <table className="text-left ">
              <tr>
                <th className="text-sm">Authority</th>
                <td
                  className={
                    complaintData?.[0]?.authority === "CM PORTAL" ||
                    complaintData?.[0]?.authority === "PM Portal"
                      ? "bg-red-500 text-white"
                      : " bg-blue-400 text-white"
                  }
                >
                  : {complaintData?.[0]?.authority}
                </td>
              </tr>

              <tr>
                <th className="text-sm">Complainant Name </th>
                <td className="text-sm">
                  : {complaintData?.[0]?.complainantName}
                </td>
              </tr>
              <tr>
                <th className="text-sm"> Contact</th>
                <td className="text-sm">
                  : {complaintData?.[0]?.contact},{" "}
                  {complaintData?.[0]?.Farmer[0]?.contact}
                </td>
              </tr>
              <tr>
                <th className="text-sm">Authority</th>
                <td className="text-sm">: {complaintData?.[0]?.authority}</td>
              </tr>
              <tr>
                <th className="text-sm">Priority</th>
                <td
                  className={
                    complaintData?.[0]?.priority === "Most Urgent"
                      ? "text-red-800"
                      : ""
                  }
                >
                  : {complaintData?.[0]?.priority}
                </td>
              </tr>
              {/* <tr>
                <th className="text-sm">Company</th>
                <td className="text-sm">: {complaintData?.[0]?.company}</td>
              </tr> */}
              <tr>
                <th className="text-sm">Stage</th>
                <td className="text-sm">
                  : {complaintData?.[0]?.Stage[0]?.stage}
                </td>
              </tr>
              <tr>
                <th className="text-sm">Assign Employee</th>
                <td className="text-sm">: {externalServicePerson.name}</td>
              </tr>
              <tr>
                <th className="text-sm">Employee coordinates</th>
                <td className="text-sm">
                  :{" "}
                  {externalServicePerson?.longitude +
                    "," +
                    externalServicePerson?.latitude || "Not Available"}
                </td>
              </tr>
              <tr>
                <th className="text-sm">Complaint Date</th>
                <td className="text-sm">
                  : {complaintData?.[0]?.created_At.split("T")[0]}
                </td>
              </tr>
              <tr>
                <th className="text-sm">Distance</th>
                <td className="text-sm">
                  :{" "}
                  {haversineDistance(
                    complaintData?.[0]?.Farmer[0]?.longitude,
                    complaintData?.[0]?.Farmer[0]?.latitude,
                    complaintData?.[0]?.RMUData.at(-1)?.longitude,
                    complaintData?.[0]?.RMUData.at(-1)?.latitude,
                  )}{" "}
                  KM
                </td>
              </tr>
              <tr>
                <th className="text-sm">RMU Number</th>
                <td className="text-sm">
                  : {complaintData?.[0]?.RMUData.at(-1)?.rmuNumber}
                </td>
              </tr>
              <tr>
                <th className="text-sm">Controller Number</th>
                <td className="text-sm">
                  : {complaintData?.[0]?.RMUData.at(-1)?.controllerNumber}
                </td>
              </tr>
              <tr>
                <th className="text-sm">SIM Number</th>
                <td className="text-sm">
                  : {complaintData?.[0]?.RMUData.at(-1)?.simNumber}
                </td>
              </tr>
              <tr>
                <th className="text-sm">Complaint Register By</th>
                <td className="text-sm">
                  : {complaintData?.[0]?.Employee?.[0]?.name}
                </td>
              </tr>
              <tr className="my-2">
                <th className="text-sm">Images</th>
                <td className="text-sm">
                  <div className="flex overflow-auto max-w-[20rem]">
                    {updated_data.length > 0 &&
                      updated_data.map((data) => (
                        <div className="overflow-hidden relative w-24 h-24 mr-2 mb-2">
                          <img
                            src={data}
                            className="rounded-lg transition-transform duration-300 ease-in-out transform hover:scale-110 w-full h-full object-cover"
                            alt="Network error"
                            onClick={() => handleImageClick(data)}
                          />
                        </div>
                      ))}
                  </div>
                </td>
              </tr>
            </table>
            <div className="bg-gray-200">
              <h3 className="text-center bg-yellow-300 text-2xl">
                C<span className="text-lg">OMPLAINT</span> D
                <span className="text-lg">ETAIL</span>
              </h3>
              <span className="p-2">
                {complaintData?.[0]?.complaintDetails}
              </span>
            </div>
          </div>
          <div className="w-2/12">
            {(empData.role !== "Tollfree") && <form onSubmit={updateComplaint}>
              <>
                <div className="mt-3">
                  <label
                    for="first_name"
                    className="block mb-2 text-sm font-medium text-gray-900"
                  >
                    PRIORITY<span className="text-red-500 h-3">*</span>
                  </label>
                  <select
                    onChange={(e) => {
                      setPriority(e.target.value);
                    }}
                    className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-sm block w-full p-2.5 "
                    id="state-select"
                  >
                    <option value="">-- Select Priority --</option>
                    <option key={1} value="Normal">
                      Normal
                    </option>
                    <option key={1} value="Urgent">
                      Urgent
                    </option>
                    <option key={1} value="Most Urgent">
                      Most Urgent
                    </option>
                  </select>
                  {/* {priorityError && <span className='text-red-500 text-xs ml-2'>Select Priority</span>} */}
                </div>
                <div className="mt-3">
                  <label
                    for="first_name"
                    className="block mb-2 text-sm font-medium text-gray-900"
                  >
                    AUTHORITY
                  </label>
                  <select
                    className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-sm focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5"
                    id="state-select"
                    value={selectedEmployee}
                    onChange={(e) => setSelectedAuthority(e.target.value)}
                  >
                    <option value="">-- Select Field Sales --</option>
                    {authority?.map(({ _id, name }) => (
                      <option key={_id} value={name}>
                        {name}
                      </option>
                    ))}
                  </select>
                </div>
                {empData.role !== "Tollfree" && (
                  <div className="mt-3">
                    <label
                      for="first_name"
                      className="block mt-3 mb-2 text-sm font-medium text-gray-900"
                    >
                      STAGE
                    </label>
                    <CommonDropdownWithId
                      Api_path={"common/showValidateStage"}
                      value={stage}
                      onChange={handleStageChange}
                      label={"Stage"}
                    />
                    {/* {priorityError && <span className='text-red-500 text-xs ml-2'>Select Priority</span>} */}
                  </div>
                )}
                {(stage === "67501cde3a9836b55dd9f417" ||
                  complaintData?.[0]?.Stage[0]?._id.toString() ===
                    "67501cde3a9836b55dd9f417") && (
                  <div className="mt-3">
                    <label
                      for="startDate"
                      className="block mb-2 text-sm font-medium text-gray-900"
                    >
                      Field Service
                      <span className="text-red-500 relative h-3 ">*</span>
                    </label>
                    <select
                      className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-sm focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                      id="state-select"
                      value={selectedEmployee}
                      onChange={(e) => setSelectedEmployee(e.target.value)}
                    >
                      <option value="">-- Select Field Sales --</option>
                      {fieldSalesList?.map(({ _id, name }) => (
                        <option key={_id} value={_id}>
                          {name}
                        </option>
                      ))}
                    </select>
                  </div>
                )}
                <>
                  <div className="">
                    <label
                      for="first_name"
                      className="block mb-2 text-sm font-medium text-gray-900"
                    >
                      Complaint Types
                      <span className="text-red-500 relative h-3">*</span>
                    </label>
                    <select
                      onChange={(e) => {
                        setComplaintDetails(e.target.value);
                      }}
                      className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-sm block w-full p-2.5 "
                      id="state-select"
                    >
                      <option value="">-- Select --</option>
                      {errorList.map(({ _id, remark }) => (
                        <option key={_id} value={remark}>
                          {remark}
                        </option>
                      ))}
                    </select>
                  </div>
                  {complaintDetails === "Others" && (
                    <div>
                      <label
                        for="details"
                        className="block mb-2 text-sm font-medium text-gray-900"
                      >
                        Complaint Details
                        <span className="text-red-500 fixed h-3">*</span>
                      </label>
                      <input
                        type="text"
                        id="first_name"
                        value={complaintOtherDetails}
                        onChange={(e) => {
                          setComplaintOtherDetails(e.target.value);
                        }}
                        className=" bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-sm block w-full p-2.5"
                        placeholder="Complaint Details"
                      />
                    </div>
                  )}
                </>
                <div>
                  <label
                    for="message"
                    className="block mt-2 mb-2 text-sm font-medium text-gray-900"
                  >
                    Remark
                  </label>
                  <textarea
                    id="message"
                    rows="4"
                    value={remark}
                    onChange={(e) => setRemark(e.target.value)}
                    className="block p-2.5 w-full text-sm text-gray-900 bg-gray-50 rounded-lg border border-gray-300 focus:ring-blue-500 "
                    placeholder="Write your thoughts here..."
                  ></textarea>
                </div>
                {complaintData?.[0]?.Stage[0]?.stage !== "Verify Stage 2" &&
                  complaintData?.[0]?.Stage[0]?.stage !==
                    "Resolve By (Field Service)" && (
                    <button
                      type="submit"
                      className="text-dark  mt-6 hover:bg-yellow-400 font-medium rounded-sm text-sm w-full sm:w-auto px-5 py-2.5 text-center firstBgColor"
                    >
                      Update
                    </button>
                  )}
                {empData.empId === "ADM002" && (
                  <button
                    type="button"
                    onClick={() => complaintReject()}
                    className="text-dark  mt-6 ml-2 hover:bg-red-400 font-medium rounded-sm text-sm w-full sm:w-auto px-5 py-2.5 text-center text-white bg-red-500"
                  >
                    Reject
                  </button>
                )}
              </>
            </form>}
            {updateResponse}
          </div>
        </div>
      </div>
      {/* Fullscreen Modal */}
      {isOpen && (
        <div className="fixed inset-0 bg-black bg-opacity-75 flex items-center justify-center z-50">
          <div className="relative">
            <img
              src={selectedImage}
              className="w-96 h-96 object-contain"
              alt="Fullscreen"
            />
            <button
              onClick={handleCloseModal}
              type="button"
              className="absolute -top-3 right-8 bg-red-600 rounded-3xl p-2 inline-flex items-center justify-center text-gray-50 hover:bg-red-400 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-indigo-500"
            >
              <span className="sr-only">Close menu</span>
              <svg
                className="h-4 w-4"
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
                aria-hidden="true"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M6 18L18 6M6 6l12 12"
                />
              </svg>
            </button>
          </div>
        </div>
      )}
    </div>
  ) : (
    <div className="h-full flex justify-center items-center ">
      <h6 className="text-4xl ">Not allow to show data </h6>
    </div>
  );
};

export default Index;
